// /**
//  * Updates the recently viewed products in localStorage.
//  */
// export class RecentlyViewed {
//   /** @static @constant {string} The key used to store the viewed products in session storage */
//   static #STORAGE_KEY = 'viewedProducts';
//   /** @static @constant {number} The maximum number of products to store */
//   static #MAX_PRODUCTS = 4;

//   /**
//    * Adds a product to the recently viewed products list.
//    * @param {string} productId - The ID of the product to add.
//    */
//   static addProduct(productId) {
//     let viewedProducts = this.getProducts();

//     viewedProducts = viewedProducts.filter((/** @type {string} */ id) => id !== productId);
//     viewedProducts.unshift(productId);
//     viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

//     localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
//   }

//   static clearProducts() {
//     localStorage.removeItem(this.#STORAGE_KEY);
//   }

//   /**
//    * Retrieves the list of recently viewed products from session storage.
//    * @returns {string[]} The list of viewed products.
//    */
//   static getProducts() {
//     return JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
//   }
// }

/**
 * Recently Viewed Products
 *
 * Stores recently viewed product handles in localStorage.
 * Maximum 4 products are stored.
 */

export class RecentlyViewed {
  static #STORAGE_KEY = 'viewedProducts';
  static #MAX_PRODUCTS = 4;

  /**
   * Add a product to recently viewed products.
   *
   * @param {string} productHandle
   */
  static addProduct(productHandle) {
    if (!productHandle) return;

    let viewedProducts = this.getProducts();

    // Remove product if it already exists
    viewedProducts = viewedProducts.filter(
      (handle) => handle !== productHandle
    );

    // Add current product at the beginning
    viewedProducts.unshift(productHandle);

    // Keep only the latest 4
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    localStorage.setItem(
      this.#STORAGE_KEY,
      JSON.stringify(viewedProducts)
    );
  }

  /**
   * Remove all recently viewed products.
   */
  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
  }

  /**
   * Get recently viewed products.
   *
   * @returns {string[]}
   */
  static getProducts() {
    try {
      const storedProducts = localStorage.getItem(this.#STORAGE_KEY);

      if (!storedProducts) {
        return [];
      }

      const products = JSON.parse(storedProducts);

      return Array.isArray(products) ? products : [];
    } catch (error) {
      console.warn(
        'Unable to read recently viewed products:',
        error
      );

      return [];
    }
  }
}
